<template>
  <div
    class="collapse-panel clpspnl"
    :class="[
      { clpspnl_reversed: toRight },
      { clpspnl_hidden: focusMode },
      {
        clpspnl_hidden_open: (halfFocusMode || focusMode) && l_open,
      },
      { clpspnl_absolute: focusMode },
      { 'clpspnl_half-absolute': halfFocusMode },
      {
        clpspnl_closed: !l_open && !focusMode,
      },
      { 'clpspnl_no-opener': !hasOpener },
    ]"
    @mouseleave="handleMouseleave"
    @mouseenter="handleMouseenter"
    v-on="swp_events"
  >
    <slot name="before" />
    <div
      class="clpspnl_inner"
      :class="innerClass"
      :style="innerStyle"
    >
      <div
        class="clpspnl_content no-scroll-track"
        @click="handleContentClick"
      >
        <slot
          :open="isOpen"
          :methods="{ toggle }"
          name="content"
        ></slot>
      </div>
    </div>
    <slot name="opener">
      <div
        v-if="hasOpener"
        class="clpspnl_opener"
        @click="handleOpenerClick"
      >
        <!-- gw_btn_hover_back -->
        <!-- style="
          --btn-back-inset: 3px auto auto 3px;
          --btn-back-height: calc(100% - 6px);
          --btn-back-width: calc(100% - 6px);
        " -->
        <div
          class="csst"
          :data-tst="`${tstPrefix}_clpspnl_opener`"
        >
          <div
            :class="{ rotated_180_before: toRight ? !isOpen : isOpen }"
            class="mdi mdi-chevron-double-right clpspnl_opener_icon clr-grey text-large transition_03"
          ></div>
          <div
            class="csst_content clpspnl_opener_tooltip text-nowrap"
            :style="`position: fixed; margin: var(--tooltip-margin);`"
          >
            {{ isOpen ? $t('tooltips.hide_sidebar') : $t('tooltips.show_sidebar') }}
          </div>
        </div>
      </div>
    </slot>
    <div
      v-if="!noTrigger"
      class="clpspnl_ftrigger"
    ></div>
    <slot name="after" />
  </div>
</template>

<script>
import swipe_mix from '@/mixins/swipe_mix'

export default {
  name: 'CollapsePanel',
  mixins: [swipe_mix],
  props: {
    open: { default: undefined },
    hasOpener: { type: Boolean, default: true },
    toggleByOpenerOnly: Boolean,
    innerClass: [Object, Array, String],
    innerStyle: [Object, String],
    persistKey: String,
    toRight: Boolean,
    noTrigger: Boolean,
    hasResizeMessage: { type: Boolean, default: true },
    toggleFn: Function,
    focusMode: Boolean,
    halfFocusMode: Boolean,
    ignoreSwipe: Boolean,
    tstPrefix: { default: 'clpspnl' },
  },
 emits: ['update:open'],
  data() {
    return {
      l_open: false,
      fTimeout: -1,
    }
  },
  created() {
    this.initialize()
  },
  methods: {
    initialize() {
      this.l_open = !!this.open
      if (this.persistKey) {
        const open = this.open || this.open === undefined
        const lcValue = localStorage.getItem(this.persistKey)
        this.l_open = lcValue ? lcValue === 'open' && open : open
      }
    },
    handleContentClick() {
      if (this.toggleByOpenerOnly) return
      if (this.focusMode) return
      if (!this.l_open) {
        this.toggle(true)
      }
    },
    handleOpenerClick() {
      if (this.focusMode) return
      this.toggle(!this.l_open)
    },
    toggle(bool) {
      if (this.toggleFn) {
        this.toggleFn(bool)
        return
      }
      this.setOpen(bool)
    },
    persist() {
      if (this.focusMode || this.halfFocusMode) return
      if (this.persistKey) {
        if (this.l_open) {
          localStorage.setItem(this.persistKey, 'open')
        } else {
          localStorage.setItem(this.persistKey, 'closed')
        }
      }
      this.$emit('update:open', this.l_open)
    },
    handleMouseenter() {
      if (this.focusMode && !this.noTrigger) {
        this.fTimeout = setTimeout(() => {
          this.l_open = true
        }, 120)
      }
    },
    handleMouseleave() {
      if (this.focusMode && !this.noTrigger) {
        clearTimeout(this.fTimeout)
        this.l_open = false
      }
    },
    setOpen(bool) {
      if (bool === undefined) {
        this.initialize()
        return
      }
      this.l_open = bool
      this.persist()
    },
    swpRight() {
      if (this.ignoreSwipe) return
      this.toggle(false)
    },
  },
  computed: {
    isOpen() {
      const res = this.focusMode ? true : this.l_open
      return res
    },
  },
  watch: {
    open: {
      immediate: false,
      handler: 'setOpen',
    },
    focusMode(bool) {
      if (bool) {
        this.l_open = this.open !== undefined ? this.open : false
      } else {
        this.initialize()
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.clpspnl {
  // --open-width: 20rem;
  --open-width: 21.5rem;
  // --open-width: 20.625rem;
  // --open-width: 20.75rem;
  // --open-width: 21rem;
  --closed-width: 3rem;
  --width: var(--open-width);
  --width-inner: var(--width);
  --width-visible: var(--width-inner);

  // --clr-back: var(--clr-black-0-1);
  --clr-back: var(--clr-black-0-3);
  --clr-back-opener: var(--clr-back);
  // --clr-back-opener-hover: var(--clr-black-2);
  --clr-back-opener-hover: var(--clr-black-1-3);
  --transition-duration: 0.22s;
  --inner-overflow: hidden;
  --inner-shadow: none;
  --inner-content-overflow-y: auto;

  --inner-left: 0;
  --inner-right: unset;
  --inner-right-hidden-open: 0;

  --tooltip-margin: -2rem 0 0 3.25rem;

  --content-padding-opened: 0.5rem;
  --content-padding-closed: 0.5rem 0rem;
  --content-padding: var(--content-padding-opened);
  --content-gap: 0.5rem;
  // --content-gap-closed: 0.25rem;

  width: 100vw;
  max-width: var(--width);
  min-height: 0;
  // margin: 0.5rem 0 0 0;
  // overflow: hidden;
  // --height: 100%;
  // --height: calc(100% - 1rem);
  // margin: 0.5rem 0;
  --height: 100%;
  height: var(--height);
  // padding: 0.5rem 0;

  position: relative;
  z-index: 4;
  transition: all var(--transition-duration);
  flex-shrink: 0;

  // --inner-radius: 0 4px 0 0;
  // --opener-radius: 0 0 4px 0;

  --inner-radius: 0;
  --opener-radius: 0;
  --opener-height: 2.5rem;
  // --inner-radius: 4px;
  &_inner {
    border-radius: var(--inner-radius);
    transition: all 0.22s;
    // transition: all 2s;
    position: absolute;
    z-index: 2;
    background: var(--clr-back);
    // backdrop-filter: blur(2px);

    // background: grey;
    overflow: var(--inner-overflow);
    left: var(--inner-left);
    right: var(--inner-right);
    width: var(--width-inner);
    height: calc(100% - var(--opener-height));
    box-shadow: var(--inner-shadow);
    // border-right: 1px solid var(--clr-black-0);
    // box-shadow: 0px 0px 2px 1px var(--clr-black-0);
    // box-shadow: 0px 0px 4px 2px red;
    // box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    // box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
    // box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
  }
  &_content {
    width: var(--open-width);
    overflow-x: hidden;
    overflow-y: var(--inner-content-overflow-y);
    height: 100%;
    padding: var(--content-padding);
    transition: padding var(--transition-duration);
    gap: var(--content-gap);
    display: flex;
    flex-direction: column;
    // display: flex;
  }
  &_ftrigger {
    position: absolute;
    width: var(--closed-width);
    top: 0;
    height: 100%;
    transition: 0.22s;
    background: transparent;
    z-index: 1;
  }
  &_absolute {
    position: absolute;
  }
  &_half-absolute {
    --inner-overflow: hidden;
    --width: var(--closed-width);
  }
  &_closed {
    --inner-overflow: hidden;
    --width: var(--closed-width);
    --content-padding: var(--content-padding-closed);
    // --content-gap: var(--content-gap-closed);
  }
  &_hidden {
    width: 0;
    --opener-height: 0;
    --inner-left: calc(-1 * var(--width));
    &_open {
      --width-inner: var(--open-width);
      // --inner-overflow: unset;
      --inner-left: 0;
    }
  }
  &_reversed {
    --width-inner: var(--open-width);
    --inner-left: unset;
    --inner-right: 0;
    .clpspnl_opener {
      flex-direction: row-reverse;

      .clpspnl_opener_tooltip {
        --tooltip-margin: -2rem 0 0 -0.25rem;
        transform: translate(-100%, 0);
      }
    }
    .clpspnl_ftrigger {
      right: 0;
    }
    &.clpspnl_closed {
      --inner-right: calc(-1 * var(--width-inner) + var(--closed-width));
    }
    &.clpspnl_absolute {
      right: 0;
    }
    &.clpspnl_half-absolute {
      --inner-left: unset;
      --inner-right: calc(-1 * var(--width-inner) + var(--closed-width));
    }
    &.clpspnl_hidden {
      --inner-left: unset;
      --inner-right: calc(-1 * var(--width-inner));
      &_open {
        --inner-right: var(--inner-right-hidden-open);
        // &.clpspnl_half-absolute {
        // --inner-right: 0;
        // }
      }
    }
  }

  &_no-opener {
    --opener-height: 0px !important;
  }
  &_opener {
    position: absolute;
    transition: all 0.22s;
    bottom: 0;
    z-index: 2;
    left: var(--inner-left);
    right: var(--inner-right);
    width: var(--width-inner);
    display: flex;
    align-items: center;
    // justify-content: center;
    justify-content: flex-end;
    height: var(--opener-height);
    backdrop-filter: blur(2px);
    // width: 100%;

    background: var(--clr-back-opener);
    // border-top: solid var(--clr-black-1-3) 1px;
    border-radius: var(--opener-radius);
    // border-top: solid var(--clr-black-2) 1px;
    cursor: pointer;
    &_icon {
      padding: 0 0.75rem;
    }
    &:hover {
      --clr-back-opener: var(--clr-back-opener-hover);
    }
  }
}
@media screen and (min-width: 768px) and (max-width: 1023px) {
  .clpspnl {
    --width: 20rem;
    --open-width: 20rem;
  }
}
@media screen and (max-width: 520px) {
  .clpspnl {
    --width: 100vw;
    --open-width: 100vw;
  }
}
</style>
